import { getAnalyticsInstance } from './config';
import { logEvent } from 'firebase/analytics';

// Verificar si estamos en un entorno de desarrollo
const isDevelopment = process.env.NODE_ENV === 'development' || window.location.hostname === 'localhost';

/**
 * Registra un evento en Firebase Analytics
 * @param {string} eventName - Nombre del evento a registrar
 * @param {Object} eventParams - Parámetros adicionales del evento (opcional)
 */
export const trackEvent = (eventName, eventParams = {}) => {
    try {
        // En desarrollo, solo registramos en la consola
        if (isDevelopment) {
            console.log(`[DEV] Evento simulado: ${eventName}`, eventParams);
            return;
        }

        const analytics = getAnalyticsInstance();
        if (analytics) {
            logEvent(analytics, eventName, eventParams);
            console.log(`Evento registrado: ${eventName}`, eventParams);
        } else {
            console.warn(`No se pudo registrar el evento ${eventName}: Analytics no está disponible`);
        }
    } catch (error) {
        console.error('Error al registrar evento en Analytics:', error);
        // No lanzar el error para evitar que la aplicación se rompa
    }
};

/**
 * Registra un evento de login en Firebase Analytics
 * @param {string} method - Método de login utilizado
 */
export const trackLogin = (method) => {
    try {
        // En desarrollo, solo registramos en la consola
        if (isDevelopment) {
            console.log(`[DEV] Login simulado con método: ${method}`);
            return;
        }

        trackEvent('login', { method });
    } catch (error) {
        console.error('Error al registrar login:', error);
    }
};

/**
 * Registra un evento de registro de usuario en Firebase Analytics
 * @param {string} method - Método de registro utilizado
 */
export const trackSignUp = (method) => {
    try {
        // En desarrollo, solo registramos en la consola
        if (isDevelopment) {
            console.log(`[DEV] Registro simulado con método: ${method}`);
            return;
        }

        trackEvent('sign_up', { method });
    } catch (error) {
        console.error('Error al registrar registro:', error);
    }
};

/**
 * Registra un evento de error en Firebase Analytics
 * @param {string} errorDescription - Descripción del error
 * @param {string} errorCode - Código de error (opcional)
 */
export const trackError = (errorDescription, errorCode = '') => {
    try {
        const errorData = {
            error_description: errorDescription,
            error_code: errorCode
        };

        // En desarrollo, solo registramos en la consola
        if (isDevelopment) {
            console.log(`[DEV] Error simulado:`, errorData);
            return;
        }

        trackEvent('app_error', errorData);
    } catch (error) {
        console.error('Error al registrar error:', error);
    }
}; 